import Item from '../Item';
import constants from '../../settings/constants';

export default class Drawer extends Item {
  getSelfHitArea() {
    const { scaledVertices } = this.data;

    // The top padding is negative, we are decreasing the hit area
    const topPadding = -constants.DISTANCE_BETWEEN_ATTACHMENTS * this.ratio;

    const vertices = [
      [scaledVertices[0][0], scaledVertices[0][1]],
      [scaledVertices[3][0], scaledVertices[3][1]],
      [scaledVertices[7][0], scaledVertices[7][1] - topPadding],
      [scaledVertices[6][0], scaledVertices[6][1] - topPadding],
      [scaledVertices[5][0], scaledVertices[5][1]],
      [scaledVertices[1][0], scaledVertices[1][1]],
    ];

    return {
      regions: [vertices],
    };
  }
}
